import { useLang } from 'hooks/lang';

import { invoiceStatusConfig } from 'entities';

import { Row, Tag } from 'components/Blocks';

import { InvoiceByStatus } from './InvoiceByStatus';
import { MarkInvoiceAsSentButton, DownloadInvoiceExcelButton } from 'pages/Invoice/components';

import { useUser } from 'hooks/user';

import { formatCurrency } from 'utils/text';
import { sortByCurrency } from '../sorters';

export function ReadyToSendToAccountant() {
  const user = useUser();
  const { t } = useLang();

  return (
    <>
      <InvoiceByStatus
        status={invoiceStatusConfig.readyToSendToAccountant.code}
        multiSelectionPropertiesClashes={['country']}
        allowMultiSelection={user.team.isInvoiceTeam}
        leftSideActionRender={(selected, overwrite) =>
          !!selected.length &&
          user.team.isInvoiceTeam && (
            <Row>
              <DownloadInvoiceExcelButton
                invoices={selected}
                onSuccess={() =>
                  overwrite((allInvoices) =>
                    allInvoices.map((invoice) =>
                      selected.find(({ id }) => id === invoice.id)
                        ? { ...invoice, downloaded: true }
                        : invoice,
                    ),
                  )
                }
              />

              <MarkInvoiceAsSentButton
                invoices={selected}
                onSuccess={() =>
                  overwrite((allInvoices) =>
                    allInvoices.filter(({ id }) => !selected.find((invoice) => id === invoice.id)),
                  )
                }
              />
            </Row>
          )
        }
        columns={[
          {
            label: t('client-name') as string,
            property: 'clientName',
            filter: true,
            sort: true,
          },
          {
            label: t('type') as string,
            property: 'type',
            filter: true,
          },
          {
            label: t('value') as string,
            getTextValue: ({ currency }) => currency,
            filter: true,
            sort: true,
            sorter: sortByCurrency,
            render: ({ value, currency, cancelationRequestId }) => (
              <Row>
                {formatCurrency(value, currency)}

                {!!cancelationRequestId && (
                  <Tag name={t('cancelation-requested')} color="warning-light" round={false} />
                )}
              </Row>
            ),
          },
        ]}
      />
    </>
  );
}
